//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {  Toast } from 'vant';
export default {
  props: {
    // 球名字默认：“球”
    text: {
      type: String,
      default: "操作"
    },
    // 球宽度默认：“40”
    itemWidth: {
      type: Number,
      default: 40
    },
    // 球高度默认：“40”
    itemHeight: {
      type: Number,
      default: 40
    },
    actions:{
        type:Array,
        default:[]
    }
  },
  data() {
    return {
      type: false,
      left: 0, // 距离左边距离
      top: 0, // 距离抬头距离
      startToMove: false, // 开始移动时候不显示
      isShow: true, // 组件是否显示
      timer: null, // 定时器
      currentTop: null, // 获取当前页面的滚动条纵坐标位置
      clientW: document.documentElement.clientWidth, //视口宽
      clientH: document.documentElement.clientHeight //视口高
    };
  },
  created() {
    // 初始化定义距离四周距离
    this.left = this.clientW - this.itemWidth - 30;
    this.top = this.clientH / 2 - this.itemHeight / 2;
  },
    inject:["submit","audit","rejected","Issued"],
  methods: {
    onCancel() {
      Toast("取消");
    },
    onSelect(item) {
        if(item.name == "提交"){
            this.submit()
        }
        if(item.name == "审核"){
            this.audit()
        }
        if(item.name == "驳回"){
            this.rejected()
        }
        if(item.name == "下发"){
            this.Issued()
        }
    },
    // 点击小球事件
    onclick() {
      this.type ? (this.type = false) : (this.type = true);
    },

    // 开始移动方法
    handleTouchStart() {
      this.startToMove = true;
      this.$refs.breathing_lamp.style.transition = "none";
    },

    // 移动中方法
    handleTouchMove(e) {
      const clientX = e.targetTouches[0].clientX; //手指相对视口的x
      const clientY = e.targetTouches[0].clientY; //手指相对视口的y
      const isInScreen =
        clientX <= this.clientW &&
        clientX >= 0 &&
        clientY <= this.clientH &&
        clientY >= 0;
      if (this.startToMove && e.targetTouches.length === 1) {
        if (isInScreen) {
          this.left = clientX - this.itemWidth / 2;
          this.top = clientY - this.itemHeight / 2;
        }
      }
    },

    // 移动结束方法
    handleTouchEnd() {
      if (this.left < this.clientW / 2) {
        this.left = 30; //不让贴边 所以设置30没设置0
        this.handleIconY();
      } else {
        this.left = this.clientW - this.itemWidth - 20; //距边30px
        this.handleIconY();
      }
      this.$refs.breathing_lamp.style.transition = "all .3s";
    },

    // 上下不贴边方法
    handleIconY() {
      if (this.top < 0) {
        this.top = 40; //不上帖上边所以设置为30 没设置0
      } else if (this.top + this.itemHeight > this.clientH) {
        this.top = this.clientH - this.itemHeight - 40; //距边30px
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/ios.vue